import React, { useEffect, useState } from "react";
import { Fab } from "@mui/material";
import "./careprovider.css";
import { Add } from "@mui/icons-material";
import ModalFormsListComponent from "./components/forms/ModalFormsListComponent";
import MemoryType from "../../service/memory/enum/MemoryType";
import { useReadMemory } from "../generic/hooks/useReadMemory";
import ConfigurationConstants from "../utils/configurationconstants";
import { currentConfiguration } from "../../service/memory/recoil/configurationstore";
import { useRecoilValue } from "recoil";
import CarePlanWrapper from "../carecoordinator/careplan/CarePlanWrapper";
import { getUserDisplayName } from "../utils/UserData";
import { teamList } from "../../components/recoil/teamsRecoil";

const CareProviderDashboard = () => {
  const [showFormsList, setShowFormsList] = useState(false);
  const [showforms, setShowForms] = useState(false);
  const configuration = useRecoilValue(currentConfiguration);
  const user = useReadMemory(MemoryType.USER);
  const displayName = getUserDisplayName();
  const teams = useRecoilValue(teamList);
  const formStatuses = ["Publish"];

  const teamNames = teams.map((team) => team?.label);

  const formattedOfficeNames = (names) => {
    if (names.length === 0) return "";
    if (names.length === 1) return ` in ${names[0]}`;
    if (names.length === 2) return ` in ${names[0]} and ${names[1]}`;
    return ` in ${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;
  };

  function onCancelButtonClicked() {
    setShowFormsList(false);
  }

  useEffect(() => {
    // Visits Tabs
    const configurationVisitsTabs =
      configuration[
        ConfigurationConstants.FEATUREACCESS_HOMEPAGE_VOLUNTEER_FORMS
      ];
    setShowForms(configurationVisitsTabs?.visibility);
  }, [configuration]);

  return (
    <section style={{ margin: 30, backgroundColor: "var(--bg-color)" }}>
      <div className="welcomeText">
        <span>
          Welcome back <b>{displayName}</b>, see how your Patients are doing
          {formattedOfficeNames(teamNames)}.
        </span>
      </div>
      <div>
        <CarePlanWrapper workforceIdentifier={user.userIdentifier} />
        {showforms && (
          <Fab
            className="view-forms-button"
            onClick={() => setShowFormsList(!showFormsList)}
          >
            <Add className="icon-color" />
          </Fab>
        )}
        {showFormsList && (
          <>
            <ModalFormsListComponent
              isModalOpen={showFormsList}
              closeModal={setShowFormsList}
              onFooterButtonClicked={onCancelButtonClicked}
              formStatuses={formStatuses}
            />
          </>
        )}
      </div>
    </section>
  );
};

export default CareProviderDashboard;
